(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bodi-account-drawer"]) return;
  try {
    
  // Global account drawer functions
  window.BODi = window.BODi || {};
  window.BODi.accountDrawer = {
    element: null,
    backdrop: null,
    scrollPosition: 0,

    init() {
      this.element = document.querySelector('.bodi-account-drawer');
      this.backdrop = document.querySelector('.bodi-account-drawer__backdrop');
      this.bindEvents();
    },

    bindEvents() {
      if (!this.element) return;

      // Close button click handler
      const closeButton = this.element.querySelector('.bodi-account-drawer__close-button');
      if (closeButton) {
        closeButton.addEventListener('click', () => this.close());
      }

      // Backdrop click handler
      if (this.backdrop) {
        this.backdrop.addEventListener('click', () => this.close());
      }

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.element.classList.contains('visible')) {
          this.close();
        }
      });
    },

    open() {
      if (!this.element || !this.backdrop) return;

      // Store current scroll position
      this.scrollPosition = window.scrollY;

      // Apply body styles to prevent scrolling (matching navigation menu behavior)
      document.body.classList.add('bodi-account-drawer-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';

      this.element.classList.add('visible');
      this.backdrop.classList.add('visible');

      // Focus management for accessibility
      const closeButton = this.element.querySelector('.bodi-account-drawer__close-button');
      if (closeButton) {
        closeButton.focus();
      }
    },

    close() {
      if (!this.element || !this.backdrop) return;

      this.element.classList.remove('visible');
      this.backdrop.classList.remove('visible');

      // Remove body styles
      document.body.classList.remove('bodi-account-drawer-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';

      // Restore scroll position
      window.scrollTo(0, this.scrollPosition);
    },
  };

  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    window.BODi.accountDrawer.init();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bodi-login-drawer"]) return;
  try {
    
  // Global login drawer functions
  window.BODi = window.BODi || {};
  window.BODi.loginDrawer = {
    element: null,
    backdrop: null,
    scrollPosition: 0,

    init() {
      this.element = document.querySelector('.login-drawer');
      this.backdrop = document.querySelector('.login-drawer__backdrop');
      this.bindEvents();
    },

    bindEvents() {
      if (!this.element) return;

      // Close button click handler
      const closeButton = this.element.querySelector('.login-drawer__close-button');
      if (closeButton) {
        closeButton.addEventListener('click', () => this.close());
      }

      // Backdrop click handler
      if (this.backdrop) {
        this.backdrop.addEventListener('click', () => this.close());
      }

      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.element.classList.contains('visible')) {
          this.close();
        }
      });
    },

    open() {
      if (!this.element || !this.backdrop) return;

      // Store current scroll position
      this.scrollPosition = window.scrollY;

      // Apply body styles to prevent scrolling (matching account drawer behavior)
      document.body.classList.add('login-drawer-open');
      document.body.style.position = 'fixed';
      document.body.style.top = `-${this.scrollPosition}px`;
      document.body.style.width = '100%';

      this.element.classList.add('visible');
      this.backdrop.classList.add('visible');

      // Focus management for accessibility
      const closeButton = this.element.querySelector('.login-drawer__close-button');
      if (closeButton) {
        closeButton.focus();
      }
    },

    close() {
      if (!this.element || !this.backdrop) return;

      this.element.classList.remove('visible');
      this.backdrop.classList.remove('visible');

      // Remove body styles
      document.body.classList.remove('login-drawer-open');
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';

      // Restore scroll position
      window.scrollTo(0, this.scrollPosition);
    },
  };

  // Initialize when DOM is loaded
  document.addEventListener('DOMContentLoaded', () => {
    window.BODi.loginDrawer.init();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-page-modules"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const ROOT_SELECTOR = '.custom-page-proven-results[data-animate="true"]';
    const VALUE_SELECTOR = '.custom-page-proven-results__stat-value[data-count-target]';
    const DURATION = 1800;
    const STAGGER = 150;

    const parseCountTarget = (rawValue) => {
      const match = rawValue.match(/^([^\d+-]*)([-+]?\d[\d,]*(?:\.\d+)?)(.*)$/);
      if (!match) return null;

      const numberString = match[2];
      const target = Number.parseFloat(numberString.replace(/,/g, ''));
      if (!Number.isFinite(target)) return null;

      return {
        prefix: match[1] || '',
        suffix: match[3] || '',
        target,
        hasComma: numberString.includes(','),
        decimalPlaces: numberString.includes('.') ? numberString.split('.')[1].length : 0,
      };
    };

    const formatNumber = (value, parsed) => {
      let formatted = parsed.decimalPlaces > 0
        ? value.toFixed(parsed.decimalPlaces)
        : Math.round(value).toString();

      if (parsed.hasComma) {
        const parts = formatted.split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        formatted = parts.join('.');
      }

      return `${parsed.prefix}${formatted}${parsed.suffix}`;
    };

    const animateValue = (element, parsed, delay) => {
      let startTime;

      const tick = (time) => {
        if (startTime === undefined) startTime = time + delay;
        if (time < startTime) {
          window.requestAnimationFrame(tick);
          return;
        }

        const progress = Math.min((time - startTime) / DURATION, 1);
        const easedProgress = 1 - Math.pow(1 - progress, 3);
        element.textContent = formatNumber(parsed.target * easedProgress, parsed);

        if (progress < 1) {
          window.requestAnimationFrame(tick);
        } else {
          element.textContent = formatNumber(parsed.target, parsed);
        }
      };

      window.requestAnimationFrame(tick);
    };

    const initializeRoot = (root) => {
      if (root.dataset.countInitialized === 'true') return;

      const values = Array.from(root.querySelectorAll(VALUE_SELECTOR))
        .filter((element) => element.offsetParent !== null)
        .map((element) => ({
          element,
          parsed: parseCountTarget(element.dataset.countTarget || ''),
        }))
        .filter(({ parsed }) => parsed !== null);

      if (!values.length) return;

      root.dataset.countInitialized = 'true';

      const reducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) return;

      values.forEach(({ element, parsed }) => {
        element.textContent = formatNumber(0, parsed);
      });

      const startAnimation = () => {
        values.forEach(({ element, parsed }, index) => {
          animateValue(element, parsed, index * STAGGER);
        });
      };

      if (!('IntersectionObserver' in window)) {
        startAnimation();
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          observer.disconnect();
          startAnimation();
        },
        { threshold: 0.35, rootMargin: '0px 0px -10% 0px' }
      );

      observer.observe(root);
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll(ROOT_SELECTOR).forEach(initializeRoot);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  document.addEventListener('sezerium:js:unload', (e) => {
      setTimeout(() => document.querySelector('.sezerium-loading')?.classList?.replace('sezerium-loading', 'sezerium-loaded'), 500);
  });
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof SezeriumCollection === 'undefined') {
        document.querySelector('.sezerium-loading')?.classList?.replace('sezerium-loading', 'sezerium-loaded');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marketing-preferences"]) return;
  try {
    
  (() => {
    const LINK_SELECTOR = '#br-consent-link a[href]';
    const POLL_INTERVAL_MS = 200;
    const TIMEOUT_MS = 20000;

    /**
     * The link's destination, or null when it has none we can navigate to: a bare
     * "#", a javascript: handler, or a link back to this same page — which would
     * reload into this script and loop. The web layer can render a placeholder href
     * and fill it in later, so a rejected link is left for a later poll.
     *
     * @param {HTMLAnchorElement} anchor
     * @returns {string | null}
     */
    const resolveHref = (anchor) => {
      const href = anchor.getAttribute('href')?.trim();

      if (!href || href === '#' || href.toLowerCase().startsWith('javascript:')) return null;

      // The href property is already resolved to an absolute URL by the browser.
      const [destination] = anchor.href.split('#');
      const [current] = window.location.href.split('#');

      return destination === current ? null : anchor.href;
    };

    /**
     * @returns {string | null}
     */
    const findHref = () => {
      const anchors = document.querySelectorAll(LINK_SELECTOR);

      for (const anchor of anchors) {
        const href = resolveHref(anchor);

        if (href) return href;
      }

      return null;
    };

    const startMarketingPreferences = () => {
      if (window.Shopify?.designMode) return;

      const root = document.querySelector('.marketing-preferences');

      // Section JavaScript is compiled into a shared bundle, so this must do nothing
      // at all unless the section is actually on the page.
      if (!(root instanceof HTMLElement)) return;

      // Signed-out visitors have no link to wait for. Sending them through BODi SSO
      // with a return_to would be an improvement, but is a separate change.
      if (root.dataset.signedIn !== 'true') {
        window.location.replace(root.dataset.homeUrl || '/');
        return;
      }

      const overlay = root.querySelector('.marketing-preferences__overlay');
      const spinner = root.querySelector('.marketing-preferences__spinner');
      const errorPanel = root.querySelector('.marketing-preferences__error');
      const startedAt = Date.now();

      /** Swaps the spinner for a retry and reports the failure so it stays measurable. */
      const fail = () => {
        const detail = { 'elapsed ms': Date.now() - startedAt };

        console.warn('[Marketing preferences] Bloomreach consent link unavailable', detail);
        window.amplitude?.track('marketing preferences unavailable', detail);

        if (spinner) spinner.hidden = true;
        if (errorPanel) errorPanel.hidden = false;
        overlay?.setAttribute('aria-busy', 'false');
      };

      const pollId = setInterval(() => {
        const href = findHref();

        if (href) {
          clearInterval(pollId);
          window.location.replace(href);
          return;
        }

        if (Date.now() - startedAt >= TIMEOUT_MS) {
          clearInterval(pollId);
          fail();
        }
      }, POLL_INTERVAL_MS);

      root.querySelector('[data-action="retry"]')?.addEventListener('click', () => {
        window.location.reload();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', startMarketingPreferences, { once: true });
    } else {
      startMarketingPreferences();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rail"] && !Shopify.designMode) return;
  try {
    
class Rail {
  constructor(container) {
    this.container = container;
    this.scrollContainer = container.querySelector('.rail-scroll-container');
    this.itemsContainer = container.querySelector('.rail-items');
    this.prevButton = container.querySelector('.rail-nav-prev');
    this.nextButton = container.querySelector('.rail-nav-next');
    this.stackMobile = container.dataset.stackMobile === 'true';
    this.stackDesktop = container.dataset.stackDesktop === 'true';
    this.init();
  }

  init() {
    this.setupNavigation();
    this.updateNavigationVisibility();
    this.updateNavPosition();
    window.addEventListener(
      'resize',
      this.debounce(() => {
        this.updateNavigationVisibility();
        this.updateNavPosition();
      }, 150)
    );
    this.scrollContainer.addEventListener('scroll', () => this.updateNavigationButtons());
    this.observeImageHeight();
  }

  setupNavigation() {
    if (!this.prevButton || !this.nextButton) return;
    this.prevButton.addEventListener('click', () => this.scrollPrev());
    this.nextButton.addEventListener('click', () => this.scrollNext());
  }

  scrollPrev() {
    const scrollAmount = this.getScrollAmount();
    this.scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
  }

  scrollNext() {
    const scrollAmount = this.getScrollAmount();
    this.scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
  }

  getScrollAmount() {
    const firstBlock = this.itemsContainer.querySelector('.shopify-block');
    if (!firstBlock) return this.scrollContainer.offsetWidth;
    const width = firstBlock.offsetWidth;
    const gap = parseInt(getComputedStyle(this.itemsContainer).gap) || 16;
    return width + gap;
  }

  updateNavigationVisibility() {
    if (!this.prevButton || !this.nextButton)
      return;
    if (window.innerWidth < 750 || this.stackDesktop) {
      this.prevButton.style.display = 'none';
      this.nextButton.style.display = 'none';
      return;
    }
    const hasOverflow = this.scrollContainer.scrollWidth > this.scrollContainer.clientWidth;
    if (hasOverflow) {
      this.prevButton.style.display = 'flex';
      this.nextButton.style.display = 'flex';
      this.updateNavigationButtons();
    } else {
      this.prevButton.style.display = 'none';
      this.nextButton.style.display = 'none';
    }
  }

  updateNavigationButtons() {
    if (!this.prevButton || !this.nextButton || window.innerWidth < 750 || this.stackDesktop)
      return;
    const scrollLeft = this.scrollContainer.scrollLeft;
    const maxScroll = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
    this.prevButton.style.display = scrollLeft <= 0 ? 'none' : 'flex';
    this.nextButton.style.display = scrollLeft >= maxScroll - 1 ? 'none' : 'flex';
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), wait);
    };
  }

  observeImageHeight() {
    const img = this.container.querySelector('.rail-img');
    if (!img || typeof ResizeObserver === 'undefined') return;
    this.resizeObserver = new ResizeObserver(() => this.updateNavPosition());
    this.resizeObserver.observe(img);
  }

  updateNavPosition() {
    if (!this.prevButton || !this.nextButton) return;
    const img = this.container.querySelector('.rail-img');
    if (!img) return;
    const imgRect = img.getBoundingClientRect();
    const centerY = imgRect.height / 2;
    const offset = Math.max(0, centerY);
    this.prevButton.style.top = `${offset}px`;
    this.nextButton.style.top = `${offset}px`;
    this.prevButton.style.transform = 'translateY(-50%)';
    this.nextButton.style.transform = 'translateY(-50%)';
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.rail-container').forEach(c => new Rail(c));
});

if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', e => {
    const container = e.target.querySelector('.rail-container');
    if (container) new Rail(container);
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["variant-rail"] && !Shopify.designMode) return;
  try {
    
  /*
   * VariantRail — self-contained horizontal scroll + nav for .variant-rail-container elements.
   * Uses a dedicated class name so it does not conflict with the Rail class in rail.liquid
   * when both sections appear on the same page.
   */
  class VariantRail {
    constructor(container) {
      this.container = container;
      this.scrollContainer = container.querySelector('.rail-scroll-container');
      this.itemsContainer = container.querySelector('.rail-items');
      this.prevButton = container.querySelector('.rail-nav-prev');
      this.nextButton = container.querySelector('.rail-nav-next');
      this.stackMobile = container.dataset.stackMobile === 'true';
      this.stackDesktop = container.dataset.stackDesktop === 'true';
      this.init();
    }

    init() {
      this.setupNavigation();
      this.updateNavigationVisibility();
      this.updateNavPosition();
      window.addEventListener(
        'resize',
        this.debounce(() => {
          this.updateNavigationVisibility();
          this.updateNavPosition();
        }, 150)
      );
      this.scrollContainer.addEventListener('scroll', () => this.updateNavigationButtons());
      this.observeImageHeight();
    }

    setupNavigation() {
      if (!this.prevButton || !this.nextButton) return;
      this.prevButton.addEventListener('click', () => this.scrollPrev());
      this.nextButton.addEventListener('click', () => this.scrollNext());
    }

    scrollPrev() {
      const scrollAmount = this.getScrollAmount();
      this.scrollContainer.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    }

    scrollNext() {
      const scrollAmount = this.getScrollAmount();
      this.scrollContainer.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    }

    getScrollAmount() {
      const firstItem = this.itemsContainer.querySelector('.variant-rail-item');
      if (!firstItem) return this.scrollContainer.offsetWidth;
      const width = firstItem.offsetWidth;
      const gap = parseInt(getComputedStyle(this.itemsContainer).gap) || 16;
      return width + gap;
    }

    updateNavigationVisibility() {
      if (!this.prevButton || !this.nextButton) return;
      if (window.innerWidth < 750 || this.stackDesktop) {
        this.prevButton.style.display = 'none';
        this.nextButton.style.display = 'none';
        return;
      }
      const hasOverflow = this.scrollContainer.scrollWidth > this.scrollContainer.clientWidth;
      if (hasOverflow) {
        this.prevButton.style.display = 'flex';
        this.nextButton.style.display = 'flex';
        this.updateNavigationButtons();
      } else {
        this.prevButton.style.display = 'none';
        this.nextButton.style.display = 'none';
      }
    }

    updateNavigationButtons() {
      if (!this.prevButton || !this.nextButton || window.innerWidth < 750 || this.stackDesktop) return;
      const scrollLeft = this.scrollContainer.scrollLeft;
      const maxScroll = this.scrollContainer.scrollWidth - this.scrollContainer.clientWidth;
      this.prevButton.style.display = scrollLeft <= 0 ? 'none' : 'flex';
      this.nextButton.style.display = scrollLeft >= maxScroll - 1 ? 'none' : 'flex';
    }

    debounce(func, wait) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(...args), wait);
      };
    }

    observeImageHeight() {
      const img = this.container.querySelector('.variant-card__img');
      if (!img || typeof ResizeObserver === 'undefined') return;
      this.resizeObserver = new ResizeObserver(() => this.updateNavPosition());
      this.resizeObserver.observe(img);
    }

    updateNavPosition() {
      if (!this.prevButton || !this.nextButton) return;
      const img = this.container.querySelector('.variant-card__img');
      if (!img) return;
      const imgRect = img.getBoundingClientRect();
      const offset = Math.max(0, imgRect.height / 2);
      this.prevButton.style.top = `${offset}px`;
      this.nextButton.style.top = `${offset}px`;
      this.prevButton.style.transform = 'translateY(-50%)';
      this.nextButton.style.transform = 'translateY(-50%)';
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.variant-rail-container').forEach(c => new VariantRail(c));
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', e => {
      const container = e.target.querySelector('.variant-rail-container');
      if (container) new VariantRail(container);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
